(() => {
  'use strict';
  let bundle = 2, timer, cartState = null, cartBusy = false, cartReadSequence = 0, lastCartTrigger = null;
  const $ = (s, root=document) => root.querySelector(s);
  const $$ = (s, root=document) => [...root.querySelectorAll(s)];
  function toast(text) {
    const el=$('.amua-toast'); if(!el)return;
    el.textContent=text;el.hidden=false;clearTimeout(timer);timer=setTimeout(()=>el.hidden=true,4200);
  }
  function scrollProduct() { $('#amua-top')?.scrollIntoView({behavior:'smooth',block:'start'}); }
  const rootUrl = () => window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat('sv-SE', {style:'currency',currency:cartState?.currency || 'SEK'}).format(Number(cents || 0)/100);
  async function cartRequest(path, data) {
    const response = await fetch(rootUrl()+path,{method:data ? 'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json',...(data ? {'Content-Type':'application/json'}:{})},...(data ? {body:JSON.stringify(data)}:{})});
    const result = await response.json();
    if(!response.ok) throw new Error(result.description || result.message || 'Varukorgen kunde inte uppdateras. Försök igen.');
    return result;
  }
  function setBusy(busy) {
    cartBusy=busy;
    $$('.amua-preview-add').forEach(button=>{button.disabled=busy;button.setAttribute('aria-busy',String(busy));});
    $$('.amua-cart-change,.amua-remove-cart').forEach(button=>button.disabled=busy);
    const checkout=$('.amua-checkout-real');if(checkout)checkout.disabled=busy || !cartState?.item_count;
    sticky();
  }
  function node(tag,className,text) {const el=document.createElement(tag);if(className)el.className=className;if(text!==undefined)el.textContent=text;return el;}
  function cartCatalog() {
    try{return JSON.parse($('.mia-cart-catalog')?.textContent || '{}').variants || {};}catch{return {};}
  }
  function cartIcon(kind) {
    const svg=node('span');
    svg.innerHTML=kind==='tag' ? '<svg width="11" height="11" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M1 1h6l8 8-6 6-8-8V1Zm3 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/></svg>' : '<svg width="15" height="17" viewBox="0 0 20 22" fill="none" aria-hidden="true"><path d="M3 5h14M7 5V2h6v3M5 5l1 15h8l1-15M8 8v8M12 8v8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return svg.firstElementChild;
  }
  function shippingProgress(cart,catalog) {
    const drawer=$('.mia-cart-drawer'),shipping=$('.mia-cart-shipping');if(!drawer || !shipping)return;
    const threshold=Math.max(0,Number(drawer.dataset.freeShippingCents)||0),currency=drawer.dataset.freeShippingCurrency;
    shipping.hidden=cart.currency!==currency;
    if(shipping.hidden)return;
    const remaining=Math.max(0,threshold-cart.total_price),qualified=cart.item_count>0 && !remaining;
    const percentage=cart.item_count ? (threshold ? Math.min(100,cart.total_price/threshold*100) : 100) : 0;
    shipping.classList.toggle('is-qualified',qualified);shipping.style.setProperty('--mia-shipping-progress',percentage+'%');
    const track=$('.mia-cart-shipping-track',shipping);track?.setAttribute('aria-valuenow',String(Math.round(percentage)));
    track?.setAttribute('aria-valuetext',qualified?'Fri frakt uppnådd':money(remaining)+' kvar till fri frakt');
    const single=Object.values(catalog).find(v=>v.title==='1 flaska' && v.available);
    const allMia=cart.items.every(item=>!!catalog[String(item.variant_id)]);
    const message=!cart.item_count ? drawer.dataset.messageEmpty : qualified ? drawer.dataset.messageAfter : allMia && single?.price>=remaining ? drawer.dataset.messageOne : drawer.dataset.messageBefore;
    const el=$('.mia-cart-shipping-message',shipping);if(el)el.textContent=(message || '').replaceAll('[amount]',money(cart.item_count ? remaining : threshold));
  }
  function renderCart(cart) {
    cartState=cart;
    const catalog=cartCatalog(),showSavings=$('.mia-cart-drawer')?.dataset.showSavings==='true';let referenceTotal=0;
    $$('.amua-cart-count').forEach(count=>{count.textContent=cart.item_count;count.hidden=!cart.item_count;});
    const headingCount=$('.mia-cart-heading-count');if(headingCount)headingCount.textContent=cart.item_count;
    const empty=$('.amua-cart-empty'),content=$('.amua-cart-content');if(empty)empty.hidden=!!cart.item_count;if(content)content.hidden=!cart.item_count;
    const list=$('.amua-cart-items');if(list){list.replaceChildren();cart.items.forEach(item=>{
      const meta=catalog[String(item.variant_id)] || {};
      const compareLine=Math.max(Number(meta.compareAtPrice)||0,Number(item.original_price)||0)*item.quantity;
      referenceTotal+=compareLine;
      const saved=Math.max(0,compareLine-item.final_line_price);
      const row=node('div','amua-cart-product');row.dataset.key=item.key;
      if(item.image){const image=node('img');const src=new URL(item.image,location.origin);src.searchParams.set('width','180');image.src=src.href;image.alt=item.product_title;image.width=76;image.height=76;image.loading='eager';image.decoding='async';row.append(image);}
      const details=node('div','amua-cart-product-details');const title=node('a','amua-cart-product-title',item.product_title);title.href=item.url;details.append(title);
      const packMatch=(item.variant_title || '').match(/^([123])\s+flask/);
      const variant=node('p','amua-cart-variant');
      if(packMatch && Number(packMatch[1])>1){variant.append(cartIcon('tag'),document.createTextNode('KÖP '+packMatch[1]));}
      else if(!packMatch && item.variant_title && item.variant_title!=='Default Title'){variant.textContent=item.variant_title;}
      else{variant.textContent='1 flaska';}
      details.append(variant);
      const controls=node('div','amua-cart-quantity-controls');const minus=node('button','amua-cart-change','−');minus.type='button';minus.dataset.key=item.key;minus.dataset.quantity=Math.max(0,item.quantity-1);minus.setAttribute('aria-label','Minska antal paket');
      const qty=node('span','amua-cart-line-quantity',String(item.quantity));qty.setAttribute('aria-label','Antal paket');
      const plus=node('button','amua-cart-change','+');plus.type='button';plus.dataset.key=item.key;plus.dataset.quantity=item.quantity+1;plus.setAttribute('aria-label','Öka antal paket');controls.append(minus,qty,plus);details.append(controls);
      const prices=node('div','mia-cart-pricing');prices.append(node('p','amua-cart-line-price',money(item.final_line_price)));
      if(showSavings && saved>0){prices.append(node('del','mia-cart-compare',money(compareLine)),node('span','mia-cart-line-saving','Du sparar '+money(saved)));}
      details.append(prices);
      const remove=node('button','amua-remove-cart');remove.type='button';remove.dataset.key=item.key;remove.setAttribute('aria-label','Ta bort '+item.product_title+' – '+(item.variant_title || ''));remove.append(cartIcon('trash'));row.append(details,remove);list.append(row);
    });}
    const subtotal=$('.amua-cart-subtotal');if(subtotal)subtotal.textContent=money(cart.total_price);
    const savings=Math.max(0,referenceTotal-cart.total_price),savedRow=$('.mia-cart-saved-row');if(savedRow)savedRow.hidden=!showSavings || !savings;
    const savedTotal=$('.mia-cart-saved-total');if(savedTotal)savedTotal.textContent='− '+money(savings);
    shippingProgress(cart,catalog);
    const checkout=$('.amua-checkout-real');if(checkout)checkout.disabled=cartBusy || !cart.item_count;
    document.dispatchEvent(new CustomEvent('mia:cart:updated',{detail:cart}));
  }
  async function refreshCart() {const sequence=++cartReadSequence;const cart=await cartRequest('cart.js');if(sequence===cartReadSequence)renderCart(cart);return cart;}
  async function openCart(refresh=true) {
    const el=$('.amua-cart-overlay');if(!el){location.href=rootUrl()+'cart';return;}
    lastCartTrigger=document.activeElement;el.hidden=false;document.body.style.overflow='hidden';sticky();$('.amua-close-cart')?.focus();
    if(refresh)try{await refreshCart();}catch(error){toast(error.message);}
  }
  function closeCart() {const el=$('.amua-cart-overlay');if(el)el.hidden=true;document.body.style.overflow='';sticky();lastCartTrigger?.focus?.();}
  async function addSelectedBundle() {
    if(cartBusy)return;
    const selected=$('[data-bundle].selected:not(:disabled)') || $('[data-bundle]:not(:disabled)');const id=Number(selected?.dataset.variantId);
    if(!id){toast('Välj ett tillgängligt paket innan du lägger det i varukorgen.');return;}
    setBusy(true);
    try{await cartRequest('cart/add.js',{items:[{id,quantity:1}]});await refreshCart();await openCart(false);}catch(error){toast(error.message);}finally{setBusy(false);}
  }
  async function changeCartItem(key,quantity) {
    if(cartBusy)return;setBusy(true);
    try{++cartReadSequence;const cart=await cartRequest('cart/change.js',{id:key,quantity});renderCart(cart);}catch(error){toast(error.message);}finally{setBusy(false);}
  }
  function init(root=document) {
    if(cartState && root.querySelector?.('.mia-cart-drawer'))renderCart(cartState);
    $$('[data-money-cents]',root).forEach(el=>el.textContent=money(el.dataset.moneyCents));
    const selected=$('[data-bundle].selected:not(:disabled)',root)||$('[data-bundle]:not(:disabled)',root);
    if(selected)$$('[data-bundle]',root).forEach(el=>{el.classList.toggle('selected',el===selected);el.setAttribute('aria-pressed',String(el===selected));});
    $$('.sb-amua-estrogen__bars',root).forEach(chart=>{const bars=$$('.sb-amua-estrogen__bar',chart);const values=bars.map(bar=>parseFloat($('.sb-amua-estrogen__value',bar)?.textContent)||0);const maximum=Math.max(1,...values);bars.forEach((bar,index)=>bar.style.setProperty('--sb-amua-bar-pct',String(values[index]/maximum*100)));});
    $$('.shop-thumbnail',root).forEach(thumb=>{
      if(thumb.dataset.amuaBound)return;thumb.dataset.amuaBound='1';
      const select=()=>{
        const gallery=thumb.closest('.product-gallery');if(!gallery)return;
        const index=Number(thumb.dataset.index);
        $$('.shop-thumbnail',gallery).forEach((x,i)=>{x.classList.toggle('active',i===index);x.setAttribute('aria-pressed',String(i===index));});
        $$('.shop-image-zoom-wrapper',gallery).forEach((x,i)=>{x.classList.toggle('active',i===index);$('img',x)?.classList.toggle('active',i===index);});
        thumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
      };
      thumb.addEventListener('click',select);thumb.addEventListener('keydown',e=>{if(['Enter',' '].includes(e.key)){e.preventDefault();select();}});
    });
    // Svep endast på huvudbilden; sidscrollning och nypzoom bevaras.
    $$('.product-gallery',root).forEach(gallery=>{
      const surface=$('.shop-main-image-wrapper',gallery);
      if(!surface || surface.dataset.miaSwipeBound)return;
      surface.dataset.miaSwipeBound='1';
      surface.style.touchAction='pan-y pinch-zoom';
      $$('img',surface).forEach(image=>image.draggable=false);
      let gesture=null, suppressClickUntil=0;
      surface.addEventListener('touchstart',event=>{
        if(event.touches.length!==1){gesture=null;return;}
        const touch=event.touches[0];
        gesture={id:touch.identifier,x:touch.clientX,y:touch.clientY,axis:null};
      },{passive:true});
      surface.addEventListener('touchmove',event=>{
        if(!gesture)return;
        if(event.touches.length!==1){gesture=null;return;}
        const touch=event.touches[0];
        if(touch.identifier!==gesture.id){gesture=null;return;}
        const dx=Math.abs(touch.clientX-gesture.x),dy=Math.abs(touch.clientY-gesture.y);
        if(!gesture.axis && Math.max(dx,dy)>8)gesture.axis=dx>dy*1.25?'x':'y';
        if(gesture.axis==='x' && event.cancelable)event.preventDefault();
      },{passive:false});
      surface.addEventListener('touchend',event=>{
        const start=gesture;gesture=null;
        if(!start || event.touches.length || start.axis==='y')return;
        const touch=[...event.changedTouches].find(item=>item.identifier===start.id);
        if(!touch)return;
        const dx=touch.clientX-start.x,dy=touch.clientY-start.y;
        const threshold=Math.max(35,Math.min(55,surface.clientWidth*.1));
        if(Math.abs(dx)<threshold || Math.abs(dx)<=Math.abs(dy)*1.25)return;
        const thumbs=$$('.shop-thumbnail',gallery);
        if(thumbs.length<2)return;
        const current=Math.max(0,thumbs.findIndex(thumb=>thumb.classList.contains('active')));
        thumbs[(current+(dx<0?1:-1)+thumbs.length)%thumbs.length]?.click();
        suppressClickUntil=Date.now()+400;
      },{passive:true});
      surface.addEventListener('touchcancel',()=>{gesture=null;},{passive:true});
      surface.addEventListener('click',event=>{
        if(Date.now()<suppressClickUntil){event.preventDefault();event.stopImmediatePropagation();}
      },true);
      surface.addEventListener('dragstart',event=>event.preventDefault());
    });
    $$('[data-tab]',root).forEach(button=>{
      if(button.dataset.amuaBound)return;button.dataset.amuaBound='1';
      button.setAttribute('role','tab');button.setAttribute('aria-selected',String(button.classList.contains('active')));
      button.addEventListener('click',()=>{
        const section=button.closest('section');
        $$('[data-tab]',section).forEach(x=>{x.classList.remove('active');x.setAttribute('aria-selected','false');});
        $$('[class^="tab-content-template"]',section).forEach(x=>x.classList.remove('active'));
        button.classList.add('active');button.setAttribute('aria-selected','true');document.getElementById(button.dataset.tab)?.classList.add('active');
      });
    });
    $$('.faq-question,.store-faq-question',root).forEach(question=>{
      if(question.dataset.amuaBound)return;question.dataset.amuaBound='1';
      if(question.tagName!=='BUTTON'){question.setAttribute('role','button');question.tabIndex=0;}
      question.setAttribute('aria-expanded','false');
      const toggle=()=>{
        const item=question.closest('.faq-item,.store-faq-item');if(!item)return;
        const wasActive=item.classList.contains('active'),container=item.parentElement;
        $$('.faq-item,.store-faq-item',container).forEach(x=>{x.classList.remove('active');$('.faq-question,.store-faq-question',x)?.setAttribute('aria-expanded','false');});
        item.classList.toggle('active',!wasActive);question.setAttribute('aria-expanded',String(!wasActive));
      };
      question.addEventListener('click',toggle);if(question.tagName!=='BUTTON')question.addEventListener('keydown',e=>{if(['Enter',' '].includes(e.key)){e.preventDefault();toggle();}});
    });
    $$('.counter-animate[data-target]',root).forEach(el=>{el.textContent=el.dataset.target+(el.dataset.suffix||'');});
    $$('.reviews-container',root).forEach(el=>el.classList.remove('reviews-carousel-swiper--pending'));
    $$('.testimonials-carousel',root).forEach(el=>{
      const track=$('.testimonials-track',el);if(!track)return;
      if(el.dataset.amuaBound)return;el.dataset.amuaBound='1';let slide=0;
      const cards=[...track.children];const go=n=>{
        const visible=window.innerWidth<750?1:3;slide=Math.max(0,Math.min(n,cards.length-visible));
        const offset=cards[slide]?.offsetLeft-(cards[0]?.offsetLeft||0);track.style.transform=`translateX(-${offset||0}px)`;
        $$('.dot',el).forEach((x,i)=>x.classList.toggle('active',i===slide));
      };
      const section=el.closest('.shopify-section')||el;
      $('.nav-button.next',section)?.addEventListener('click',()=>go(slide+1));$('.nav-button.prev',section)?.addEventListener('click',()=>go(slide-1));
      $$('.dot',section).forEach(x=>x.addEventListener('click',()=>go(Number(x.dataset.slide)||0)));
      let touchX=0;el.addEventListener('touchstart',e=>touchX=e.touches[0].clientX,{passive:true});el.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-touchX;if(Math.abs(dx)>35)go(slide+(dx<0?1:-1));},{passive:true});
    });
  }
  document.addEventListener('click',event=>{
    const target=event.target.closest('button,a,.shop-mobile-arrow');if(!target)return;
    if(target.matches('[data-bundle]')){
      bundle=Number(target.dataset.bundle);$$('[data-bundle]').forEach(x=>{x.classList.toggle('selected',x===target);x.setAttribute('aria-pressed',String(x===target));});
      sticky();

    }
    if(target.matches('[data-amua-home-tab]')){
      const section=target.closest('.sb-amua-benefits');
      $$('[data-amua-home-tab]',section).forEach(x=>x.setAttribute('aria-selected',String(x===target)));
      $$('[data-amua-home-panel]',section).forEach(x=>x.hidden=x.dataset.amuaHomePanel!==target.dataset.amuaHomeTab);
    }
    if(target.matches('.sb-amua-ingredients__arrow')){
      const section=target.closest('.sb-amua-ingredients'),track=$('.sb-amua-ingredients__track',section);
      track?.scrollBy({left:(target.classList.contains('sb-amua-ingredients__arrow--next')?1:-1)*track.clientWidth*.85,behavior:'smooth'});
    }
    if(target.matches('.amua-preview-add,[data-sticky-purchase]')){event.preventDefault();addSelectedBundle();}
    if(target.matches('.amua-open-cart')){event.preventDefault();openCart();}
    if(target.matches('.amua-close-cart'))closeCart();
    if(target.matches('.amua-remove-cart')){event.preventDefault();changeCartItem(target.dataset.key,0);}
    if(target.matches('.amua-cart-change')){event.preventDefault();changeCartItem(target.dataset.key,Number(target.dataset.quantity));}
    if(target.matches('[data-preview-info]')){event.preventDefault();toast('Den här länken är ännu inte konfigurerad. Kontakta kundtjänst om du behöver hjälp.');}
    if(target.matches('[data-scroll-product]')){event.preventDefault();scrollProduct();}
    if(target.matches('.shop-mobile-arrow')){
      const gallery=target.closest('.product-gallery'),thumbs=$$('.shop-thumbnail',gallery);const index=thumbs.findIndex(x=>x.classList.contains('active'));const delta=target.classList.contains('shop-mobile-next-arrow')?1:-1;thumbs[(index+delta+thumbs.length)%thumbs.length]?.click();
    }
    if(target.matches('.nav-button')&&target.closest('#amua-reviews')){
      const section=target.closest('.shopify-section'),viewport=$('.reviews-container',section);viewport?.scrollBy({left:(target.classList.contains('next')?1:-1)*viewport.clientWidth*.9,behavior:'smooth'});
    }
  });
  document.addEventListener('click',event=>{if(event.target.matches('.amua-cart-overlay'))closeCart();});
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape')closeCart();
    if(event.key==='Tab'&&!$('.amua-cart-overlay')?.hidden){
      const focusable=$$('button,a[href],[tabindex="0"]',$('.amua-cart-drawer')).filter(x=>x.offsetParent!==null);const first=focusable[0],last=focusable.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
    }
  });
  const sticky=()=>{
    const button=$('.shop-add-to-cart-wrapper .amua-preview-add');
    const selected=$('[data-bundle].selected:not(:disabled)') || $('[data-bundle]:not(:disabled)');
    const overlay=$('.amua-cart-overlay');
    const cartOpen=!!overlay && !overlay.hidden;
    const visible=!!button && button.getBoundingClientRect().bottom<0 && !cartOpen;
    $$('[data-sticky-add-to-cart]').forEach(bar=>{
      bar.classList.toggle('amua-visible',visible);
      bar.style.setProperty('pointer-events',visible?'auto':'none','important');
      bar.setAttribute('aria-hidden',String(!visible));
      bar.inert=!visible;
      $$('[data-sticky-purchase]',bar).forEach(trigger=>{
        trigger.disabled=cartBusy || !selected?.dataset.variantId;
        trigger.setAttribute('aria-busy',String(cartBusy));
        if(selected){
          const packageTitle=$('.amua-bundle-card-title',selected)?.textContent?.trim() || '';
          const buttonText=$('.button-text',trigger)?.textContent?.trim() || trigger.textContent.trim();
          trigger.setAttribute('aria-label',buttonText+' – '+packageTitle);
        }
      });
    });
  };
  window.addEventListener('scroll',sticky,{passive:true});
  window.addEventListener('resize',sticky,{passive:true});
  document.addEventListener('load',sticky,true);
  document.addEventListener('shopify:section:load',e=>{init(e.target);sticky();});
  document.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('[data-amua-home-panel]');if(panel){const button=$('[data-amua-home-tab="'+panel.dataset.amuaHomePanel+'"]');button?.click();}const ingredient=e.target.closest('[class^="tab-content-template"]');if(ingredient)$('[data-tab="'+ingredient.id+'"]')?.click();});
  window.addEventListener('pageshow',event=>{sticky();if(event.persisted)refreshCart().catch(()=>{});});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{init();sticky();refreshCart().catch(()=>{});});else{init();sticky();refreshCart().catch(()=>{});}
})();
